<template>
  <div class="card is-w-60v">
    <header class="bandeau-modal card-header"/>
    <div class="card-content">
      <section class="has-text-centered">
        <div class="mgb-50px">
          <h1 class="title is-size-3 has-text-centered">
            {{ title }}
          </h1>
        </div>
        <uploader
          v-if="!file"
          ref="upload" class="mgt-30px pd-20pxupload-box"
          @added="file = $event" @removed="file = null"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :extensions="/\.(xlsx)$/i"
          @filePrevented="filePrevented"
          :size="piecesJointesConfiguration.maxSize || taillePjLimite">
          <div class="columns">
            <div class="column">
              <b-icon icon="file-multiple" size="is-large" type="is-primary"/>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-paddingless is-size-6 has-text-weight-bold">
              <h1 class=" is-size-4 has-text-weight-bold">
                {{ $t('importExcel.dragDrop.title') }}
              </h1>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-paddingless  is-size-6">
              {{ $t('importExcel.dragDrop.formatAndMaxSize') }}
            </div>
          </div>
        </uploader>
        <error-msg-component
          :messages="errorDataFile"
          :error="!!(errorDataFile.length)"
          :title="'addEditCivilite.error.problemOccurred'"
          @close="errorDataFile = []"
          class="has-text-left"
          fixe-heigth
        />
        <table v-if="errorFiles.length" class="table mgt-20px is-fullwidth">
          <tbody>
            <tr v-for="fileError in errorFiles" :key="fileError.id">
              <td> {{fileError.name}} </td>
              <td class="has-text-danger"> {{fileError.errorMessage}} </td>
            </tr>
          </tbody>
        </table>
        <table v-if="file" class="table mgt-20px is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t('importExcel.recap.fileName') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{file.name}}</td>
              <td>
                <b-icon
                  @click.native="deleteFile"
                  class="is-cursor-pointer"
                  icon="delete" type="is-danger"/>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <footer class="mgt-20px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('importExcel.actions.cancel') }}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="ajouter" :disabled="!file">
            {{ $t('importExcel.actions.add') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import Uploader from '@/components/general/uploader';
import readAndCreateLignes from '@/services/excel/produitReseauTempoDispo/importObjectifDispo';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Attachments = createNamespacedHelpers('attachments');

export default {
  components: {
    Uploader,
    errorMsgComponent,
  },
  data() {
    return {
      file: null,
      errorFiles: [],
      errorDataFile: [],
      taillePjLimite: TAILLE_PJ_LIMITE,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...Attachments.mapGetters({
      piecesJointesConfiguration: 'configuration',
    }),
  },
  methods: {
    filePrevented(error) {
      error.file.errorMessage = error.message;
      this.errorFiles.push(error.file);
    },
    deleteFile() {
      this.file = null;
      this.errorDataFile = [];
    },
    async ajouter() {
      const loadingComponent = this.$buefy.loading.open();
      this.errorDataFile = [];
      try {
        await readAndCreateLignes(this.file, this.errorDataFile);
        loadingComponent.close();
        this.$emit('is-update');
        this.$parent.close();
      } catch (e) {
        loadingComponent.close();
      }
    },
  },
};
</script>
